import React from 'react';
import Layout from './components/layout/Layout';
import NewStoreForm from './components/form/NewStoreForm';
import Confirm from './components/confirm/Confirm';
import WaitingForConfimation from './components/waitingForConfirmation/WaitingForConfirmation';
import { ImageLargeContainer, ImageLarge, LayoutStyle, BodyStyle, FooterStyle } from './styles';
import { withCookies, Cookies } from 'react-cookie';
import CookieConsent from 'react-cookie-consent';

export class App extends React.Component {
  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      hasSubmitted: cookies.get('hasSubmit') || false,
      isVerified: cookies.get('isVerfied') || false,
      email: cookies.get('email') || '',
      allowCookies: cookies.get('CookieConsent') || false
    };
    this.handleReq = this.handleReq.bind(this);
    this.handleVerifyStatusResponse = this.handleVerifyStatusResponse.bind(this);
  }

handleReq (req) {
  if(!req){
    return;
  }
  const { cookies } = this.props;
  this.setState(
    {
      hasSubmitted: true,
      email: req.email
    }
  );
  if(this.state.allowCookies) {
    cookies.set('hasSubmit', true, { path: '/' })
    cookies.set('email', req.email, { path: '/' })
  }
}

handleVerifyStatusResponse(res) {
  const { cookies } = this.props;
  this.setState({
    isVerified: res
  })
  if(this.state.allowCookies) {
    cookies.set('isVerfied', true, { path: '/' });
  }
}

  render() {
    return (
      <LayoutStyle>
        {!this.state.isVerified ?
          !this.state.hasSubmitted ?
          <div>
            <BodyStyle>
              <NewStoreForm onSubmit={this.handleReq}/>
              <ImageLargeContainer>
                <ImageLarge src='https://zervicepoint.com/wp-content/uploads/sign-up/zp_self-service_laptop_and_mobile_technician.png'/>
              </ImageLargeContainer>
            </BodyStyle>
            <FooterStyle>
              <CookieConsent
                location='bottom'
                buttonText='Allow cookies'
                style={{ background: 'rgba(49,54,65,.85)', fontSize: '14px', textAlign: 'center'}}
                buttonStyle={{ background: '#2AAECD', borderRadius: '5px', color: '#FFFFFF', fontSize: '12px', display: "flex", justifyContent: 'center', flex: '1 0 100px', margin: "7px 7rem 7px 15px" }}
                contentStyle={{margin: "7px 7rem 7px 15px"}}
                expires={150}
                >We use cookies to give you the best experience on our website. To find out more, read our <a href='https://zervicepoint.com/privacy-policy/' target='_blank' style={{ textDecoration: 'none', color: '#2aaecd' }}>Privacy Policy</a></CookieConsent>
            </FooterStyle>
          </div>
          :
          <WaitingForConfimation email={this.state.email} handleResponse={this.handleVerifyStatusResponse}/>
        :
        <Confirm cookies={this.props.cookies}/>}
      </LayoutStyle>
    );
  }
}

export default withCookies(App);
